import React from 'react';
import { connect } from 'react-redux';
import { createSelector } from 'reselect';

import Slider from 'material-ui/Slider';
import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';

import { getChart } from '../../../core/chart';
import { generationsActions, getSelectedGeneration } from '../../../core/generations';
import { setSelectedCell } from '../../../core/ui';

import { range } from 'lodash';
import { _Slider, _Label, _Field } from '../styled-sidebar';
import { StyledScrollable } from '../../common/styled-base';

import theme from '../../../styles/theme';

class GenerationMenu extends React.Component {

  render() {
    const { 
      chart,
      generation, 
      setThickness,
      setFontSize,
      setCellType,
      setTextPathStyle,
      setOffset,
      setSelectedCell,
      setStrokeVisible,
    } = this.props;


    const generationsText = ['1st', '2nd', '3rd', '4th', '5th', '6th', '7th', '8th', '9th', '10th'];

    return (
      <StyledScrollable padding='15px'>        

        <div>
          <_Label>Selected Generation:</_Label>
          <SelectField
            className="kt-select"
            value={generation.index}
            labelStyle={{color: 'rgba(255,255,255,0.8)'}}
            selectedMenuItemStyle={{color: theme.primary}}
            onChange={(e, index, value) => setSelectedCell({ascendancy: Math.pow(2, value), generation: value, index: 0})}
            >
            {range(0, chart.generations).map(i => (
              <MenuItem key={i} value={i} primaryText={`${generationsText[i]} Generation`} />
            ))}
          </SelectField>
        </div>


        <_Field>
          <_Label>Radius: {generation.thickness}</_Label>
          <_Slider>
            <Slider
              disableFocusRipple={true}
              className="slider-ui" 
              min={0} 
              max={300} 
              step={1} 
              value={generation.thickness} 
              onChange={(e, value) => setThickness(generation.index, value)} />
          </_Slider>
        </_Field>

        <_Field>
          <_Label>Font Size: {generation.fontSize}</_Label>
          <_Slider>
            <Slider 
              disableFocusRipple={true}
              className="slider-ui"
              min={0} 
              max={120} 
              step={1} 
              value={generation.fontSize}
              onChange={(e, value) => setFontSize(generation.index, value)} />
          </_Slider>
        </_Field>

        <div>
          <_Label>Information Displayed:</_Label>
          <SelectField
            className="kt-select"
            value={generation.cellType}
            labelStyle={{color: 'rgba(255,255,255,0.8)'}}
            selectedMenuItemStyle={{color: theme.primary}}
            onChange={(e, index, value) => setCellType(generation.index, value)}
            >
            <MenuItem value={"horizontal-date"} primaryText="Horizontal w/ Date" />
            <MenuItem value={"horizontal-multiline"} primaryText="Horizontal Multiline" />
            <MenuItem value={"horizontal-centered"} primaryText="Horizontal Curved" />
            <MenuItem value={"horizontal-straight"} primaryText="Horizontal Straight" />
            <MenuItem value={"vertical-date"} primaryText="Vertical w/ Date" />
            <MenuItem value={"vertical-inline-date"} primaryText="Vertical w/ inline Date" />
            <MenuItem value={"vertical-multiline"} primaryText="Vertical Multiline" />
            <MenuItem value={"vertical-centered"} primaryText="Vertical Curved" />
          </SelectField>
        </div>

        <_Field>
          <_Label>Text Offset: {generation.offset}</_Label>
          <_Slider>
            <Slider 
              disableFocusRipple={true}
              className="slider-ui"
              min={-100} 
              max={100} 
              step={1} 
              value={generation.offset}
              onChange={(e, value) => setOffset(generation.index, value)} />
          </_Slider>
        </_Field>

        <div>
          <_Label>Stroke Visible:</_Label>
          <SelectField
            className="kt-select"
            value={generation.strokeVisible}
            labelStyle={{color: 'rgba(255,255,255,0.8)'}}
            selectedMenuItemStyle={{color: theme.primary}}
            onChange={(e, index, value) => setStrokeVisible(generation.index, value)}
            >
            <MenuItem value={true} primaryText="Yes" />
            <MenuItem value={false} primaryText="No" />
          </SelectField>
        </div>

      </StyledScrollable>
    )
  }
}

const mapStateToProps = createSelector(
  getChart,
  getSelectedGeneration,
  (chart, generation) => ({
    chart,
    generation,
  })
)

const mapDispatchToProps = Object.assign({setSelectedCell}, generationsActions)
export default connect(mapStateToProps, mapDispatchToProps)(GenerationMenu);


// WEBPACK FOOTER //
// ./src/components/menu/generation-menu/index.js